import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {QRCodeItemObject} from '@PosterWhiteboard/items/qr-code-item.class';

export function useGetKeyFromQRItem<T extends keyof QRCodeItemObject>(key: T): QRCodeItemObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item?.gitype === ITEM_TYPE.QR_CODE) {
      const itemCopy = item as QRCodeItemObject;
      if (itemCopy?.[key] !== undefined) {
        return itemCopy[key];
      }
    }

    return undefined;
  });
}
